import React from 'react';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';

const KidsStayFreeBadge = () => {
  const { t } = useTranslation();
  return <WhiteBadgeStyled>{t('vacation.oss.cards.badgets.childrenstayfree')}</WhiteBadgeStyled>;
};

export default KidsStayFreeBadge;
